import { Link } from 'react-router-dom'
import { assets } from '../assets/assets'
import axiosInstance from '../api/axiosInstance';
import { useEffect, useState } from 'react';

const Profile = () => {

  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
   
    const fetchProfile = async () => {
      try {
        setLoading(true);
        // const response = await axios.get(`${config.apiUrl}/profile`, {
        //   headers: {
        //     Authorization: `Bearer ${config.token}`,
        //   }
        // });
        const response = await axiosInstance.get('/profile');

        setProfile(response.data.data);

      } catch (error) {
        console.error('Failed to fetch profile:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, []);

  return (
    <div>
      {/* ======================= breadcrumb start  ============================ */}
      <div className="breadcrumb_sec">
        <div className="container">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to='/account' >My Account</Link>
              </li>
              <li className="breadcrumb-item">My Profile</li>
            </ol>
          </nav>
          <div className="support pb-3">
            <h3>My Profile</h3>
            <p>Your details here will be reflected in your future contributions</p>
          </div>
        </div>
      </div>
      {/* ======================= breadcrumb end  ============================ */}

      {/* =======================  Profile start  ============================ */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
          <div className="spinner-border text-danger" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="profile_section pt-5 pb-5">
          <div className="container">
            <div className="row">
              <div className="profile d-flex justify-content-between align-items-center">
                <div>
                  <div className="d-sm-flex align-items-center">
                    <div className="flex-shrink-0 mb-3 mb-sm-0 me-0 me-sm-3">
                      <img src={assets.user_img} className="img-fluid" alt="Profile" />
                    </div>
                    <p className="name">{profile?.name || 'Guest'}</p>
                  </div>
                </div>
                <div className="justify-content-end">
                  <Link to='' className="btn btn-primary edit-btn shadow-none">Edit Profile</Link>
                </div>
              </div>
            </div>

            <div className="col-xl-6">
              <div className="profile_form">
                <form action="#" method="post">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="firstName" className="form-label">First Name*</label>
                      <input type="text" className="form-control" id="firstName" name="first_name" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="lastName" className="form-label">Last Name*</label>
                      <input type="text" className="form-control" id="lastName" name="last_name" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="email" className="form-label">Email*</label>
                      <input type="email" className="form-control" id="email" name="email" required />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="whatsapp" className="form-label">Whatsapp Number*</label>
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control border-start-0"
                          id="whatsapp"
                          name="whatsapp"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <label htmlFor="address" className="form-label">Address*</label>
                      <input type="text" className="form-control" id="address" name="address" required />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="panCard" className="form-label">PAN Card</label>
                      <input type="text" className="form-control" id="panCard" name="pan_card" />
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default Profile
